import React from "react";
import { createRoot } from "react-dom/client";
import { I18nProvider } from "@nelurio/i18n";
import "@nelurio/ui/styles.css";
import "./styles/app.css";
import { App } from "./app";

if ("serviceWorker" in navigator && import.meta.env.PROD) {
  window.addEventListener("load", () => {
    if (!("serviceWorker" in navigator)) return;
    navigator.serviceWorker.register("/sw.js").then((registration) => {
      // Deployed a new build? activate it immediately — no stale PWA.
      registration.addEventListener("updatefound", () => {
        const worker = registration.installing;
        worker?.addEventListener("statechange", () => {
          if (worker.state === "installed" && navigator.serviceWorker.controller) worker.postMessage("skip-waiting");
        });
      });
      // The SW already skips waiting; once the NEW worker takes control, reload
      // this tab once so it runs the fresh bundle (never on the very first claim).
      let firstClaim = !navigator.serviceWorker.controller;
      navigator.serviceWorker.addEventListener("controllerchange", () => {
        if (firstClaim) { firstClaim = false; return; }
        window.location.reload();
      });
      // Always up to date: check for a new build on focus and every 30 minutes.
      const check = () => { try { registration.update().catch(() => undefined); } catch { /* private mode */ } };
      document.addEventListener("visibilitychange", () => { if (!document.hidden) check(); });
      window.setInterval(check, 30 * 60 * 1000);
      check();
    }).catch(() => undefined);
  });
}

createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <I18nProvider defaultLocale={(import.meta.env.VITE_DEFAULT_LOCALE as never) || "de-DE"}>
      <App />
    </I18nProvider>
  </React.StrictMode>
);

// remove the boot splash once React has painted
requestAnimationFrame(() => {
  document.getElementById("boot-splash")?.remove();
});
